// extracted by mini-css-extract-plugin
export default {"addToCartControl":"uZ-z","giftCard":"vZ-z","btnContainer":"wZ-z","cartButton":"xZ-z","disabled":"yZ-z"};